import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { useStore } from '@mcn-platform/models';
import ItemGrid from './item/ItemList';
/**
 * Shows list of courses in either a grid card view or a listing view.
 * @todo Add an in the navigation and other components for the Category page
 */
const ItemListPage = observer(() => {
    const store = useStore();
    // @ts-ignore
    const [categoryId] = store.categories.keys();
    return (
    // @ts-ignore
    _jsx(ItemGrid, { categoryId: categoryId, context: { portal: store.currentPortal } }));
});
export default ItemListPage;
//# sourceMappingURL=CourseListPage.js.map